import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { Button } from 'components/Button'
import ProjectsHero from 'assets/projects-hero.webp'

export function Hero() {
  const { t } = useTranslation('projects.page')

  return (
    <div className="relative mt-8 flex flex-col items-center overflow-hidden md:mt-0 lg:mb-10 lg:flex-row lg:justify-between lg:gap-[72px]">
      <div className="flex max-w-2xl flex-col items-center px-6 lg:min-w-[576px] lg:items-start">
        <h1 className="mb-5 text-center font-default text-[36px] font-semibold leading-9 -tracking-[1.5px] lg:mb-6 lg:text-left lg:text-[56px] lg:leading-[56px] lg:-tracking-[2.2px]">
          {t('project.hero.title')}
        </h1>
        <p className="mb-5 max-w-lg text-center text-sm font-light leading-6 text-dark-gray lg:text-left lg:text-base lg:leading-7">
          {t('project.hero.subtitle')}
        </p>
        <Button
          variant="tertiary"
          href="/causes"
          className="-mx-6 rounded-3xl px-6 text-sm sm:h-10 sm:max-h-none"
          locale={false}
        >
          {t('project.hero.cta')}
        </Button>
      </div>
      <div className="relative h-[349px] w-[612px] scale-[0.8] overflow-hidden lg:scale-100">
        <Image
          src={ProjectsHero}
          alt="International projects"
          width={612}
          height={349}
          className="absolute left-0 min-w-[612px]"
          priority
        />
      </div>
    </div>
  )
}
